import request from '@/utils/request'

// 获取当前进行中的抽奖活动信息
export function getActiveInfo() {
  return request({
    url: '/client/gw/api/v1/draw_task/status/opened',
    method: 'get'
  })
}

// 获取抽奖记录
export function getLuckyDrawRecord(id, params) {
  return request({
    url: `/client/gw/api/v1/draw_task/${id}/draw_records`,
    method: 'get',
    params
  })
}
// 获取抽奖次数
export function getLuckyDrawCount(id) {
  return request({
    url: `/client/gw/api/v1/draw_task/${id}/user/rest_count`,
    method: 'get',
  })
}

// 获取用户抽奖记录
export function getUserRecord(id,params) {
  return request({
    url: `/client/gw/api/v1/draw_task/${id}/user/draw_records`,
    method: 'get',
    params
  })
}

// 开始抽奖
export function startLuckyDraw(id) {
  return request({
    url: `/client/gw/api/v1/draw_task/${id}/start`,
    method: 'post',
  })
}



// 获取所有商品套餐
export function getProductlist() {
  return request({
    url: `/client/gw/api/v1/product/productlist`,
    method: 'get'
  })
}

// 开始抽奖
export function startLuckyDrawWX(id) {
  return request({
    url: `/client/gw/api/v1/draw_task/${id}/start`,
    method: 'post',
    headers: {
      TokenType: 'official'
    }
  })
}

// 获取抽奖次数
export function getLuckyDrawCountWX(id) {
  return request({
    url: `/client/gw/api/v1/draw_task/${id}/user/rest_count`,
    method: 'get',
    headers: {
      TokenType: 'official'
    }
  })
}

// 获取用户抽奖记录
export function getUserRecordWX(id,params) {
  return request({
    url: `/client/gw/api/v1/draw_task/${id}/user/draw_records`,
    method: 'get',
    params,
    headers: {
      TokenType: 'official'
    }
  })
}
